import { Link } from 'react-router-dom';

interface RankingItem {
  rank: number;
  title: string;
  category: string;
  hot: number;
}

interface HotRankingProps {
  items: RankingItem[];
}

export default function HotRanking({ items }: HotRankingProps) {
  return (
    <section className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            热门榜单
          </h2>
          <p className="mt-2 text-foreground-600 text-sm">实时热度排行，发现大家都在看什么</p>
        </div>
      </div>
      <div className="bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
        {items.map((item, index) => (
          <Link
            key={item.rank}
            to={`/article/${item.rank}`}
            className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3 md:py-4 cursor-pointer hover:bg-background-100 transition-colors ${
              index < items.length - 1 ? 'border-b border-background-200/70' : ''
            }`}
          >
            <div className={`w-8 h-8 flex items-center justify-center rounded-full text-sm font-bold flex-shrink-0 ${
              item.rank === 1
                ? 'bg-accent-500 text-background-50 dark:text-foreground-950'
                : item.rank === 2
                ? 'bg-secondary-400 text-background-50 dark:text-foreground-950'
                : item.rank === 3
                ? 'bg-primary-400 text-background-50 dark:text-foreground-950'
                : 'bg-background-200 text-foreground-600'
            }`}>
              {item.rank}
            </div>
            <div className="flex-1 min-w-0">
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 truncate">
                {item.title}
              </h3>
              <span className="text-xs text-foreground-500">{item.category}</span>
            </div>
            <div className="flex items-center gap-1 text-accent-500 flex-shrink-0">
              <i className="ri-fire-line text-sm"></i>
              <span className="text-sm font-semibold">{item.hot.toLocaleString()}</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}